import React from "react";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import "./StudentBedroomCard.css";

function ResidentCard({ person, onClick, dragHandleProps }) {
  const isAdult = person.type === "adult";

  const imgPaths = {
    student: {
      male: ["/assets/img/boy1.png"],
      female: ["/assets/img/girl1.png"],
      unknown: ["/assets/img/boy1.png"],
    },
    adult: {
      male: ["/assets/img/man1.png"],
      female: ["/assets/img/woman1.png"],
      unknown: ["/assets/img/unknown.png"],
    },
  };

  const normalisedGender = String(person.gender || "")
    .trim()
    .toLowerCase();

  const genderKey =
    normalisedGender === "male"
      ? "male"
      : normalisedGender === "female"
      ? "female"
      : "unknown";

  const imgSet = imgPaths[person.type]?.[genderKey] || ["/assets/img/unknown.png"];
  const imgPath = process.env.PUBLIC_URL + imgSet[0];

  return (
    <div
      className={`tc my-card dib br3 pa3 ma2 grow bw2 shadow-5 ${
        isAdult ? "adult" : ""
      }`}
      onClick={onClick}
      style={{ position: "relative" }}
    >
      <div
        {...dragHandleProps}
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "absolute",
          top: 6,
          right: 6,
          cursor: "grab",
          touchAction: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 28,
          height: 28,
          borderRadius: 6,
          background: "rgba(255,255,255,0.85)",
          zIndex: 2,
        }}
      >
        <DragIndicatorIcon fontSize="small" />
      </div>

      <img className="br-100 h3 w3 dib" alt={person.id} src={imgPath} />
      <div>
        <p>
          {person.name} {person.surname || ""}
        </p>
        {person.bookingGroupName && (
          <p style={{ fontSize: "0.8em", color: "#555" }}>
            {person.bookingGroupName}
          </p>
        )}
        {!isAdult && <p>Age: {person.age}</p>}
        {person.roomRequirements && (
          <p style={{ fontStyle: "italic" }}>
            {person.roomRequirements}
          </p>
        )}
        {isAdult && (
          <p style={{ fontSize: "0.9em", color: "#aa0000" }}>Adult</p>
        )}
        {isAdult && person.role && (
          <p style={{ fontWeight: "bold", color: "#aa0000" }}>
            {person.role}
          </p>
        )}
      </div>
    </div>
  );
}

export default ResidentCard;